import React, { useEffect } from 'react';
import { useAppContext } from './context/AppContext';
import Dashboard from './components/Dashboard';
import LoginForm from './components/LoginForm';
import { fetchUserProfile } from './services/fetchUserProfile';
import { fetchActivities } from './services/fetchActivities';

function App() {
  const { base_url, token, setToken, setUser, setCompany, setActivities, history } = useAppContext();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const urlToken = urlParams.get('token');
    if (urlToken && urlToken.length > 25) {
      setToken(urlToken);
    }
  }, [setToken]);

  useEffect(() => {
    if (token) {
      fetchUserProfile(token, base_url, setUser, setCompany);
      fetchActivities(token, base_url, history, setActivities);
    }
  }, [token, base_url, setUser, setCompany, setActivities, history]);


  return (
    <div className="App">
      { token ? ( <Dashboard /> ) : ( <LoginForm /> )}
    </div>
  );
}

export default App;
